import React from 'react';

export const ApplicationContext = React.createContext({
    smartbannerVisibility: false,
});
ApplicationContext.displayName = 'ApplicationContext';
